const FILES = import.meta.glob("../sounds/table/*.mp3", { eager: true, query: "?url", import: "default" }) as Record<string, string>;

const URLS = new Map(Object.entries(FILES).map(([path, url]) => [path.slice(path.lastIndexOf("/") + 1, -".mp3".length), url]));

// The fingerprinted URL of a recording of the table's library (config/table_sounds.yml), by key.
export const urlOf = (key: string): string | undefined => URLS.get(key);
